import React, { HTMLAttributes } from "react";
import StyledProfileIcon from "./ProfileIcon.styled";
import { ReactComponent as ProfileIconSvg } from "../../../assets/icons/profile.svg";

const ProfileIcon = (props: HTMLAttributes<HTMLDivElement>) => (
  <StyledProfileIcon {...props}>
    <ProfileIconSvg />
  </StyledProfileIcon>
);

export default ProfileIcon;
